var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOsrGrowthStage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.33 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:none;stroke:#18c60b;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "1 1 1 58 58 58"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 2,
    y1: 10,
    x2: 6,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 2,
    y1: 16,
    x2: 6,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 2,
    y1: 22,
    x2: 6,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 2,
    y1: 28,
    x2: 6,
    y2: 28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 14.33,
    cy: 42.29,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 39.33,
    cy: 34.79,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 54.33,
    cy: 7.29,
    r: 5
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 41.73,
    y1: 30.41,
    x2: 51.94,
    y2: 11.67
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 19.33,
    y1: 40.99,
    x2: 34.33,
    y2: 36.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 6.05,
    y1: 53.96,
    x2: 11.61,
    y2: 46.48
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsrGrowthStage);
export default __webpack_public_path__ + "static/media/OSRGrowthStage.9514585c727535b398cdd84929ada435.svg";
export { ForwardRef as ReactComponent };